export const uiBorderColor = 0x788a87